import { Action } from '@ngrx/store';


export enum AdmEmpresaActionTypes {
  GET_ADM_EMPRESA = '[ADM_EMPRESA] GetEmpresa',
  SET_ADM_EMPRESA = '[ADM_EMPRESA] SetEmpresa',
  EDIT_ADM_EMPRESA = '[ADM_EMPRESA] EditEmpresa',
  DELETE_ADM_EMPRESA = '[ADM_EMPRESA] DeleteEmpresa',
  SUCESS_EMPRESA = '[ADM_EMPRESA] SuccessEmpresa',
  FAIL_EMPRESA = '[ADM_EMPRESA] FailEmpresa',
}

export class AdmGetEmpresa implements Action {
  readonly type = AdmEmpresaActionTypes.GET_ADM_EMPRESA;
  constructor() {}
}

export class AdmSetEmpresa implements Action {
  readonly type = AdmEmpresaActionTypes.SET_ADM_EMPRESA;
  constructor(public DatosEmpresa: any) {}
}
export class AdmEditEmpresa implements Action {
  readonly type = AdmEmpresaActionTypes.EDIT_ADM_EMPRESA;
  constructor(public DatosEmpresa: any) {}
}

export class AdmDeleteEmpresa implements Action {
  readonly type = AdmEmpresaActionTypes.DELETE_ADM_EMPRESA;
  constructor(public ObjDel: any) {}
}

export class AdmSuscesEmpresa implements Action {
  readonly type = AdmEmpresaActionTypes.SUCESS_EMPRESA;
  constructor(public Respuesta: any , public TipoR: string) {}
}

export class AdmFailEmpresa implements Action {
  readonly type = AdmEmpresaActionTypes.FAIL_EMPRESA;
  constructor(public Respuesta: any) {}
}


export type AdmEmpresaAcciones =
    | AdmGetEmpresa
    | AdmSetEmpresa
    | AdmEditEmpresa
    | AdmDeleteEmpresa
    | AdmSuscesEmpresa
    | AdmFailEmpresa;
